// Owner-uploaded photos of Agung Wiwin Homestay (verified content)

// === GARDEN ROOM ===
const GARDEN_ROOM = {
  // Bedroom with king bed + swan towel art
  bedSwan:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/r1vf0a46_WhatsApp%20Image%202026-06-04%20at%2015.29.10%20%281%29.jpeg",
  // Bedroom with open doorway looking into lush garden
  doorway:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/e7ln4m3k_WhatsApp%20Image%202026-06-04%20at%2015.29.10.jpeg",
};

// === POOL VIEW ROOM ===
const POOL_VIEW_ROOM = {
  // Bedroom with rattan/grass fan wall art + green bench
  bedRattan:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/s68elq3a_WhatsApp%20Image%202026-06-04%20at%2015.29.10%20%282%29.jpeg",
  // Hi-res bathroom with subway tile, stone basin, rain shower
  bathroom:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/h2pp5ari_DSC03179-1.jpg",
  // Hi-res room interior with doorway opening to swimming pool courtyard
  roomWithPoolView:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/qd0ywjx6_DSC03166-1.jpg",
};

// === SHARED AMENITIES ===
const AMENITY = {
  // The actual swimming pool with sun loungers and tropical garden
  swimmingPool:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/x4dvpsre_WhatsApp%20Image%202026-06-04%20at%2015.35.36.jpeg",
  // Outdoor pool framed by lush palms and frangipani trees (sunset light)
  outdoorPoolGarden:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/0cy9c0cs_outdoor%20pool%20and%20garden.jpeg",
  // Outdoor billiards table in lush garden
  billiards:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/1mgkvbvn_WhatsApp%20Image%202026-06-04%20at%2015.35.36%20%281%29.jpeg",
  // The Garden Cafe restaurant — wooden pavilion with rattan pendant lights
  restaurant:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/jucodub5_restaurant.jpeg",
};

// Stock placeholders for sections without owner photos yet
const STOCK = {};

// === BIG ROOM (owner photos — professional) ===
const BIG_ROOM = {
  bedroom:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/ca5df97230bb5269_AGWH4011-HDR.webp",
  bedroomStraight:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/5de25912ca544a47_AGWH4032-HDR.webp",
  tvDesk:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/c793feb6e4f01a63_AGWH4052-HDR.webp",
  bathroomWide:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d54c45e35d2bebf2_AGWH4081-HDR.webp",
  terrace:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/bae48631074413cc_AGWH4097-HDR.webp",
  bathtub:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d54c45e35d2bebf2_AGWH4081-HDR.webp",
};

// === DELUXE POOL VIEW (owner photos) ===
const DLX_POOL = {
  photo1:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d2281d8236e5892f_AGWH3852-HDR.webp",
  photo2:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/a7b67c75464aa8e1_AGWH3807-HDR.webp",
  photo3:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/a69f19fc29a54c88_AGWH3797-HDR.webp",
  photo4:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/74b8cf245134fe04_AGWH3787-HDR.webp",
  photo5:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/efe4e59d4a5fa409_AGWH3757-HDR.webp",
};

// === DELUXE GARDEN VIEW (owner photos) ===
const DLX_GARDEN = {
  photo1:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d9392480405821e1_AGWH3972-HDR.webp",
  photo2:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/19a969532029bd00_AGWH3982-HDR.webp",
  photo3:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/a63d8aaff0f17d0e_AGWH3962-HDR.webp",
  photo4:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d73aa369f96ef867_AGWH3932-HDR.webp",
  photo5:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/f476d3fea3a05e81_AGWH3892-HDR.webp",
};

// === STANDARD POOL VIEW (owner photos) ===
const STD_POOL = {
  photo1:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/b77279d71ebdd5e3_AGWH3752-HDR.webp",
  photo2:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/b47c71de4b124d75_AGWH3712-HDR.webp",
  photo3:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d5bbcd119345188d_AGWH3681-HDR.webp",
  photo4:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/bb932af82d189486_AGWH3667-HDR.webp",
  photo5:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/bfe210dea96c7ea8_AGWH3651-HDR.webp",
};

// === STANDARD GARDEN VIEW (owner photos) ===
const STD_GARDEN = {
  bedroom:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/cf029a6537a712ec_AGWH3632-HDR.webp",
  terrace:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/53c0de436071e844_AGWH3527-HDR.webp",
  interior:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/762d0304066d427e_AGWH3623-HDR.webp",
  bathroom:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/8a7c47b665658952_AGWH3573-HDR.webp",
  exterior:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/cc88104d2bd20b3b_AGWH3547-HDR.webp",
};

// === BRAND LOGOS ===
const BRAND = {
  homestayLogo:
    "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/596tdaku_3.jpg",
  laundryLogo:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/d1cc98ff9aafc294_WhatsApp%20Image%202026-09-20%20at%2015.42.55.jpeg",
  laundryPricePoster:
    "https://customer-assets-0z36b82j.emergentagent.net/job_agung-wiwin-bali/artifacts/1250a2e6ac6de984_WhatsApp%20Image%202026-10-09%20at%2011.36.29.jpeg",
};

export const BRAND_LOGOS = BRAND;

// === FOOD (The Garden Cafe dishes) ===
const FOOD = [
  "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/2us56mvs_DSC03288.jpg",
  "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/0xw1oi7r_DSC03292.jpg",
  "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/o181m4y7_DSC03254.jpg",
  "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/a8dx6mfs_Gambar%20WhatsApp%202025-01-10%20pukul%2013.51.03_dd9b4bc8.jpg",
  "https://customer-assets.emergentagent.com/job_agung-wiwin-bali/artifacts/zgcjwwmc_Gambar%20WhatsApp%202025-01-10%20pukul%2015.41.01_514d30dd.jpg",
];

export const FOOD_GALLERY = FOOD;

export const IMG = {
  // Hero — showcase pool + garden vibe with real photos
  heroPool: AMENITY.outdoorPoolGarden,
  heroGarden: GARDEN_ROOM.doorway,
  heroRoom: POOL_VIEW_ROOM.roomWithPoolView,
  // Garden / pool atmosphere
  poolWide: AMENITY.swimmingPool,
  gardenPath: AMENITY.outdoorPoolGarden,
  gardenLush: GARDEN_ROOM.doorway,
  // Rooms — owner photos
  roomGarden: GARDEN_ROOM.doorway, // garden view through doorway
  roomPool: POOL_VIEW_ROOM.roomWithPoolView, // pool view through doorway
  roomBig: BIG_ROOM.bedroom, // owner Big Room bedroom photo
  // Restaurant — owner photos
  restaurantHero: AMENITY.restaurant,
  smoothieBowl: FOOD[1],
  coffeeFlatLay: FOOD[3],
  // Laundry (stock until owner photos arrive)
  laundryHero:
    "https://images.unsplash.com/photo-1604335079120-1edca0aaa97f?auto=format&fit=crop&w=1600&q=80",
  laundryFolded:
    "https://images.pexels.com/photos/7691101/pexels-photo-7691101.jpeg?auto=compress&cs=tinysrgb&w=1400",
  // Gallery — best owner photos
  g1: AMENITY.outdoorPoolGarden,
  g2: GARDEN_ROOM.doorway,
  g3: AMENITY.restaurant,
  g4: GARDEN_ROOM.bedSwan,
  g5: POOL_VIEW_ROOM.bedRattan,
  g6: BIG_ROOM.bathroomWide,
};

// Per-room photo galleries + hero image per room id (used in room detail cards)
// Standard tiers reuse Deluxe photos until owner uploads dedicated Standard photos.
export const ROOM_HERO = {
  "standard-garden": STD_GARDEN.bedroom,
  "standard-pool": STD_POOL.photo3,
  "deluxe-garden": DLX_GARDEN.photo5,
  "deluxe-pool": DLX_POOL.photo5,
  "big-room": BIG_ROOM.bedroom,
};

export const ROOM_GALLERY = {
  "standard-garden": [
    STD_GARDEN.bedroom,
    STD_GARDEN.terrace,
    STD_GARDEN.interior,
    STD_GARDEN.bathroom,
    STD_GARDEN.exterior,
  ],
  "standard-pool": [
    STD_POOL.photo3,
    STD_POOL.photo2,
    STD_POOL.photo1,
    STD_POOL.photo4,
    STD_POOL.photo5,
  ],
  "deluxe-garden": [
    DLX_GARDEN.photo5,
    DLX_GARDEN.photo1,
    DLX_GARDEN.photo2,
    DLX_GARDEN.photo3,
    DLX_GARDEN.photo4,
  ],
  "deluxe-pool": [
    DLX_POOL.photo5,
    DLX_POOL.photo2,
    DLX_POOL.photo1,
    DLX_POOL.photo3,
    DLX_POOL.photo4,
  ],
  "big-room": [
    BIG_ROOM.bedroom,
    BIG_ROOM.bedroomStraight,
    BIG_ROOM.tvDesk,
    BIG_ROOM.bathroomWide,
    BIG_ROOM.terrace,
  ],
  // Legacy aliases (if used elsewhere)
  garden: [GARDEN_ROOM.doorway, GARDEN_ROOM.bedSwan],
  pool: [POOL_VIEW_ROOM.roomWithPoolView, POOL_VIEW_ROOM.bedRattan, POOL_VIEW_ROOM.bathroom],
  big: [BIG_ROOM.bedroom, BIG_ROOM.bathroomWide, BIG_ROOM.bathtub],
};
